const DummyCandidate = {
  name: "Rajeev",
  place: ["Ernakulam", "Kollam", "Alapuzha"],
  pfNumber: 123442,
  address: "Ernakulam, Kerala, India",
};
export default DummyCandidate;
